import { LoadingOverlayService } from "../../services/loading-overlay/loading-overlay.service";
import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { of } from "rxjs";
import { distinctUntilChanged, debounceTime, delay, switchMap } from "rxjs/operators";

@Component({
  selector: "loading-overlay",
  templateUrl: "./loading-overlay.component.html",
  styleUrls: ["./loading-overlay.component.scss"]
})
export class LoadingOverlayComponent implements OnInit {
  public loading: boolean;

  constructor(
    public loadingOverlayService: LoadingOverlayService,
    private cdRef: ChangeDetectorRef
  ) { }

  public ngOnInit() {
    this.loadingOverlayService
      .getLoadingSubjectAsObservable()
      .pipe(
        switchMap(loading => {
          if (loading) {
            return of(true);
          } else {
            return of(false).pipe(delay(300));
          }
        }),
        distinctUntilChanged())
      .subscribe(res => {
        this.loading = res;
        this.cdRef.detectChanges();
      });
  }
}
